import React from 'react';
import styles from './ConfigPanel.module.scss';
import { BoxLayer, Layer } from './BoxLayer';
import { ArrayActionItem, ArrayActions } from '../../hooks/useArrayActions';
import { GlobalColors, ItemSchema } from '../../assets';
import { DragDropContext, Droppable, DropResult } from 'react-beautiful-dnd';
import { AddItemButton } from './AddItemButton';
import { useWhyUpdate } from '../../hooks/useWhyUpdate';

interface Props {
  items: ArrayActionItem<Layer>[];
  itemArrActions: ArrayActions<Layer>;
  globalColors: string[];
  itemSchemas: Record<string, ItemSchema>;
  setGlobalColors: (updater: (old: string[]) => string[]) => any;
}

export function ConfigPanel(p: Props) {
  const {
    items,
    globalColors,
    setGlobalColors,
    itemSchemas,
    itemArrActions,
  } = p;
  useWhyUpdate('COnfig panel', p);

  const onDragEnd = React.useCallback(
    (result: DropResult) =>
      result.destination &&
      itemArrActions.reorder(result.source.index, result.destination.index),
    [itemArrActions]
  );

  return (
    <>
      <BoxLayer
        colors={globalColors}
        changeColors={setGlobalColors}
        schema={GlobalColors}
      />

      <AddItemButton
        items={items}
        itemSchemas={itemSchemas}
        itemArrActions={itemArrActions}
      />

      <div className={styles.panel}>
        <DragDropContext
          // onDragStart={() => console.log("Drag started")}
          // onDragUpdate={() => console.log("Drag update")}
          onDragEnd={onDragEnd}>
          <Droppable droppableId={'main-droppable'}>
            {provided => {
              return (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {items
                    .map(l => ({ ...l, schema: itemSchemas[l.item.item] }))
                    .map(({ item, replace, remove, schema }, i) => {
                      return (
                        <BoxLayer
                          key={item.item}
                          draggableIndex={i}
                          remove={remove}
                          colors={item.colors}
                          changeLayer={replace}
                          schema={schema}
                        />
                      );
                    })}
                  {provided.placeholder}
                </div>
              );
            }}
          </Droppable>
        </DragDropContext>
      </div>
    </>
  );
}

export * from './BoxLayer';
